import Marquee from "react-fast-marquee";
import { INDUSTRIES } from "../../data/content";

export const IndustryMarquee = () => (
  <div className="border-y border-[#c9a24e]/20 bg-black py-8">
    <Marquee speed={38} gradient gradientColor="#000000" gradientWidth={120}>
      {INDUSTRIES.concat(INDUSTRIES).map((item, i) => (
        <span key={i} className="mx-10 inline-flex items-center gap-10">
          <span className="font-serif-e text-3xl italic text-[#e5e7eb] md:text-5xl">
            {item}
          </span>
          <span className="h-2 w-2 rotate-45 bg-[#c9a24e]" />
        </span>
      ))}
    </Marquee>
  </div>
);
